module.exports = __webpack_public_path__ + "static/media/kid-peace-sign-cupcake.576f3c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-peace-sign-cupcake.jpg
// module id = 806
// module chunks = 0